/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/src/components/shad/accordion";
import { client } from "@/src/sanity";
import { useQuery } from "@tanstack/react-query";
import { PortableText } from "@portabletext/react";
import { myPortableTextComponents } from "@/src/utils";
import { cn } from "@/lib/utils";
import { textVariants } from "@/src/components/Text/Text";

const SideHistory = () => {
  const getFaqs = () => {
    const query = `
 *[_type == "faq_type" && title == "Wallet"][0]{
    "faqs": *[_type=="faq" && references(^._id )][0...5]{
    title,
    body
  }
}
`;

    return client.fetch(query);
  };

  const { data } = useQuery({
    queryFn: getFaqs,
    queryKey: ["get_faq"],
  });

  return (
    <div className="grid gap-3 divide-y  divide-gray-200 dark:divide-grey-500 py-3">
      {data?.faqs?.map((item: any, index: number) => (
        <Accordion
          key={index}
          type="single"
          collapsible
          className="w-full flex flex-col px-4 "
        >
          <AccordionItem value={item?.title} className=" rounded-md">
            <AccordionTrigger
              className={cn(
                textVariants({ font: "semibold" }),
                "data-[state=open]:bg-[#2F60E0] data-[state=open]:text-white rounded-t-md px-2"
              )}
            >
              <div className="text-left">{item?.title}</div>
            </AccordionTrigger>
            <AccordionContent className="bg-[#EDF0FA] dark:bg-grey-500 rounded-b-md pb-0 pt-0">
              <div className="py-4  px-5 rounded-lg">
                <PortableText
                  value={item?.body}
                  components={myPortableTextComponents}
                  // components={/* optional object of custom components to use */}
                />
              </div>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      ))}
    </div>
  );
};

export default SideHistory;
